// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ScrollToEndButton_scrollToBottom__H8j2T {
  background: #FFFFFF;
  box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.04), 0px 8px 16px rgba(0, 0, 0, 0.08);
  width: 38px;
  height: 38px;
  border-radius: 100%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  position: relative;
  cursor: pointer;
}

.ScrollToEndButton_newMessages__CGJvq {
  position: absolute;
  top: 0;
  left: 50%;
  min-width: 18px;
  padding: 0 4px;
  height: 18px;
  transform: translate(-50%, -50%);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: #4778EE;
  color: white;
  border-radius: 9px;
  font-weight: 400;
  font-size: 11px;
  line-height: 16px;
  letter-spacing: 0.4px;
  pointer-events: none;
  -webkit-user-select: none;
          user-select: none;
}`, "",{"version":3,"sources":["webpack://./src/components/chats/ui/ScrollToEndButton/ScrollToEndButton.module.scss"],"names":[],"mappings":"AAAA;EACE,mBAAA;EACA,6EAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EAEA,oBAAA;EACA,mBAAA;EACA,uBAAA;EAEA,kBAAA;EACA,eAAA;AADF;;AAIA;EAGE,kBAAA;EACA,MAAA;EACA,SAAA;EACA,eAAA;EACA,cAAA;EACA,YAAA;EACA,gCAAA;EAEA,oBAAA;EACA,mBAAA;EACA,uBAAA;EAEA,mBAAA;EACA,YAAA;EACA,kBAAA;EAEA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,qBAAA;EAEA,oBAAA;EACA,yBAAA;UAAA,iBAAA;AAPF","sourcesContent":[".scrollToBottom {\n  background: #FFFFFF;\n  box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.04), 0px 8px 16px rgba(0, 0, 0, 0.08);\n  width: 38px;\n  height: 38px;\n  border-radius: 100%;\n\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n\n  position: relative;\n  cursor: pointer;\n}\n\n.newMessages {\n  $height: 18px;\n\n  position: absolute;\n  top: 0;\n  left: 50%;\n  min-width: 18px;\n  padding: 0 4px;\n  height: 18px;\n  transform: translate(-50%, -50%);\n\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n\n  background: #4778EE;\n  color: white;\n  border-radius: $height / 2;\n\n  font-weight: 400;\n  font-size: 11px;\n  line-height: 16px;\n  letter-spacing: 0.4px;\n\n  pointer-events: none;\n  user-select: none;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"scrollToBottom": `ScrollToEndButton_scrollToBottom__H8j2T`,
	"newMessages": `ScrollToEndButton_newMessages__CGJvq`
};
export default ___CSS_LOADER_EXPORT___;
